<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    name="status"
    :label="'Type'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect
      :autofocus="!isReadonly"
      name="status"
      v-model="invoice.invoice_type"
      :options="invoiceTypes"
      valueField="value"
      textField="text"
      :readonly="isReadonly"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    name="reference_invoice"
    :label="'Reference Invoice'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    :required="isReferenceInvoiceRequired"
  >
    <div
      slot="description"
      v-if="invoice.invoice_type"
    >
      {{ messages.invoiceTypeHelp[invoice.invoice_type] }}
    </div>
    <ItpFormSelect2
      name="reference_invoice"
      v-model="invoice.reference_invoice"
      :dataSource="() => ({
    name: 'suggest_invoice',
    parameters: {
      invoice_kind: invoice.invoice_kind,
      parent_invoice_type: invoice.invoice_type,
      client_id: invoice.client ? invoice.client.id: null
    }
  })"
      valueField="id"
      textField="name"
      bind-object
      :readonly="isReadonly"
      :disabled="!invoice.invoice_type"
      clearable
      use-option-template-for-selected-option
      optionTemplate="<UcSuggestInvoiceOption :option=&quot;option&quot; hide-invoice-kind></UcSuggestInvoiceOption>"
      @optionSelected="evh_4186377094414664_optionSelected($event, {})"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <hr
    class="my-4"
  >
  </hr>
  <ItpFormGroup
    name="client"
    :label="'Own company'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect2
      name="company"
      v-model="invoice.company"
      bind-object
      :dataSource="b_6917646200545441_dataSource"
      required
      :disabled="preventChangeCompany"
      optionTemplate="<UcSuggestCompanyOption :option=option></UcSuggestCompanyOption>"
      use-option-template-for-selected-option
      @selected="evh_6917646200545441_selected($event, {})"
    >
    </ItpFormSelect2>
    <DIV
      class="mt-2 p-2 bg-light"
      slot="description"
    >
      <DIV
        class="d-flex justify-content-end"
      >
        <ItpFormCheckbox
          name="editCompany"
          v-model="editCompany"
          is-switch
        >
          {{ 'Toggle editor'|pgettext('Invoice') }}
        </ItpFormCheckbox>
      </DIV>
      <UcInvoicePartyPanel
        :item="invoice.company"
        display-name
        v-if="invoice.company && !editCompany"
      >
      </UcInvoicePartyPanel>
      <FieldsetInvoiceParty
        :invoice="invoice"
        path="company"
        v-if="invoice.company && editCompany"
      >
      </FieldsetInvoiceParty>
    </DIV>
  </ItpFormGroup>
  <ItpFormGroup
    name="client"
    :label="'Client'|gettext"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect2
      name="client"
      v-model="invoice.client"
      bind-object
      :dataSource="b_6424600534600827_dataSource"
      required
      :disabled="preventChangeClient"
      optionTemplate="<UcSuggestCompanyOption :option=option></UcSuggestCompanyOption>"
      use-option-template-for-selected-option
      @selected="evh_6424600534600827_selected($event, {})"
    >
    </ItpFormSelect2>
    <DIV
      class="mt-2 p-2 bg-light"
      slot="description"
    >
      <DIV
        class="d-flex justify-content-end"
      >
        <ItpFormCheckbox
          name="editClient"
          v-model="editClient"
          is-switch
        >
          {{ 'Toggle editor'|pgettext('Invoice') }}
        </ItpFormCheckbox>
      </DIV>
      <UcInvoicePartyPanel
        :item="invoice.client"
        display-name
        v-if="invoice.client && !editClient"
      >
      </UcInvoicePartyPanel>
      <FieldsetInvoiceParty
        :invoice="invoice"
        path="client"
        v-if="invoice.client && editClient"
      >
      </FieldsetInvoiceParty>
    </DIV>
  </ItpFormGroup>
  <hr
    class="my-4"
  >
  </hr>
  <ItpFormGroup
    name="invoice_number"
    :label="'Invoice Number'|gettext"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    required
    v-if="isIncomingInvoice"
  >
    <ItpFormInput
      name="invoice_number"
      v-model="invoice.invoice_number"
      :readonly="isReadonly"
      :placeholder="'Enter invoice number'|pgettext('Invoice/invoice_number/placeholder')"
      required
      @blur="evh_2754826507016131_blur($event, {})"
    >
    </ItpFormInput>
    <div
      class="alert alert-in-form alert-warning"
      v-if="duplicateInvoiceNumber"
    >
      <ItpIcon
        fa="exclamation-circle"
      >
      </ItpIcon>
      <span>
        {{ messages.duplicateInvoiceNumber }}
      </span>
    </div>
  </ItpFormGroup>
  <ItpFormGroup
    name="invoice_date"
    :label="'Invoice Date'|gettext"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormDatetime
      name="invoice_date"
      v-model="invoice.invoice_date"
      :readonly="isReadonly"
      required
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    name="fulfillment_date"
    :label="'Fulfillment Date'|gettext"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormDatetime
      name="fulfillment_date"
      v-model="invoice.fulfillment_date"
      :readonly="isReadonly"
      required
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    name="due_date"
    :label="'Due Date'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormDatetime
      name="due_date"
      v-model="invoice.due_date"
      :readonly="isReadonly"
      required
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    name="payment_method"
    :label="'Payment Method'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
    class="col"
  >
    <ItpFormSelect
      name="payment_method"
      v-model="invoice.payment_method"
      :options="paymentMethods"
      :readonly="isReadonly"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <hr
    class="my-4"
  >
  </hr>
  <ItpFormGroup
    name="status"
    :label="'Status'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    required
    v-if="isIncomingInvoice"
  >
    <ItpFormSelect
      name="status"
      v-model="invoice.status"
      :options="incomingInvoiceStatuses"
      valueField="value"
      textField="text"
      :readonly="isReadonly"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    name="accounting_date"
    :label="'Accounting Date'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
  >
    <ItpFormDatetime
      name="accounting_date"
      v-model="invoice.accounting_date"
      :readonly="isReadonly"
    >
    </ItpFormDatetime>
  </ItpFormGroup>
  <ItpFormGroup
    name="billing_period"
    :label="'Billing Period'|gettext"
    contentClass="form-row"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    v-if="invoice.billing_period"
  >
    <DIV
      class="col-3"
    >
      <ItpFormDatetime
        name="billing_period_start"
        v-model="invoice.billing_period.start"
        :readonly="isReadonly"
        :placeholder="'From'|pgettext('BillingPeriod')"
      >
      </ItpFormDatetime>
    </DIV>
    <DIV
      class="col-3"
    >
      <ItpFormDatetime
        name="billing_period_end"
        v-model="invoice.billing_period.end"
        :readonly="isReadonly"
        :placeholder="'To'|pgettext('BillingPeriod')"
      >
      </ItpFormDatetime>
    </DIV>
  </ItpFormGroup>
  <ItpFormGroup
    name="currency"
    :label="'Currency'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="2"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect
      name="currency"
      v-model="invoice.currency"
      :options="currencies"
      valueField="code"
      textField="code"
      :readonly="isReadonly"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    name="currency"
    :label="'Exchange rate'|pgettext('Invoice')"
    contentClass="form-row"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <DIV
      class="col-3"
    >
      <ItpFormInput
        type="number"
        name="exchange_rate"
        v-model="invoice.exchange_rate"
        :readonly="isReadonly"
        :placeholder="'Rate'|pgettext('Invoice')"
      >
      </ItpFormInput>
    </DIV>
    <DIV
      class="col-4"
    >
      <ItpFormDatetime
        name="exchange_rate_date"
        v-model="invoice.exchange_rate_date"
        :readonly="isReadonly"
        :placeholder="'Date'|pgettext('Invoice')"
      >
      </ItpFormDatetime>
    </DIV>
    <DIV
      class="col-5"
    >
      <ItpFormInput
        name="exchange_rate_bank"
        v-model="invoice.exchange_rate_bank"
        :readonly="isReadonly"
        :placeholder="'Provider'|pgettext('Invoice')"
      >
      </ItpFormInput>
    </DIV>
  </ItpFormGroup>
  <ItpFormGroup
    name="language"
    :label="'Language'|gettext"
    labelColsMd="4"
    contentColsMd="4"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect
      name="language"
      v-model="invoice.language"
      :options="languages"
      :readonly="isReadonly"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    name="expense_type"
    :label="'Expense Type'|gettext"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect
      name="expense_type"
      v-model="invoice.expense_type"
      :options="expenseTypes"
      :readonly="isReadonly"
      valueField="name"
      textField="name"
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="tags"
    :label="'Categories'|pgettext('Invoice')"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect2
      name="tags"
      multiple
      taggable
      :options="tags"
      v-model="invoice.tags"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="vat_period"
    :label="'VAT Period'|pgettext('Invoice')"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect2
      name="vat_period"
      v-model="invoice.vat_period"
      bind-object
      :options="vatPeriods"
      valueField="id"
      textField="name"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="4"
    contentColsMd="8"
    name="email_template"
    :label="'Email template'|pgettext('Invoice')"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormSelect2
      name="email_template"
      v-model="invoice.email_template"
      bind-object
      :options="templates"
      valueField="id"
      textField="name"
    >
    </ItpFormSelect2>
  </ItpFormGroup>
  <hr
    class="my-4"
  >
  </hr>
  <ItpFormGroup
    name="reference_number"
    :label="'Reference Number'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormInput
      name="reference_number"
      v-model="invoice.reference_number"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="order_number"
    :label="'Order Number'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormInput
      name="order_number"
      v-model="invoice.order_number"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    name="file_number"
    :label="'File Number'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormInput
      name="file_number"
      v-model="invoice.file_number"
      :readonly="isReadonly"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <hr
    class="my-4"
  >
  </hr>
  <ItpFormGroup
    name="notes"
    :label="'Notes'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormTextarea
      name="notes"
      v-model="invoice.notes"
      :readonly="isReadonly"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
  <ItpFormGroup
    name="internal_notes"
    :label="'Internal Notes'|pgettext('Invoice')"
    labelColsMd="4"
    contentColsMd="8"
    :labelAlign="labelAlign"
    class="col"
  >
    <ItpFormTextarea
      name="internal_notes"
      v-model="invoice.internal_notes"
      :readonly="isReadonly"
      rows="4"
    >
    </ItpFormTextarea>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class FieldsetInvoiceHeader extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  onReferenceInvoiceSelected(...args: any[]) {
    const { option, value } = args[0];

    this.selectClient({ clientId: option.client.id })
  }

  selectClient(...args: any[]) {
    const { clientId } = args[0];
    return this.$fn
      .fetch('get_invoice_party_details', { parameters: { id: clientId } })
      .then(data => this.setData('invoice.client', data))
      .catch(err => this.onError(err))
  }

  selectCompany(...args: any[]) {
    const { companyId } = args[0];
    return this.$fn
      .fetch('get_invoice_party_details', { parameters: { id: companyId } })
      .then(data => this.setData('invoice.company', data))
      .catch(err => this.onError(err))
  }

  checkInvoiceNumber(...args: any[]) {
    const invoiceNumber = args[0];

    return this.$fn
      .fetch('check', { parameters: { kind: 'invoice', op: 'exists', query: invoiceNumber, partner_id: _.get(this.invoice, 'client.id') } })
      .then(d => this.duplicateInvoiceNumber = d.passed)
      .catch(err => this.duplicateInvoiceNumber = false)
  }

  @Prop({
    required: true,
    type: Object,
  })
  invoice!: object;

  @Watch('invoice')
  onInvoice(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("invoice")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  messages!: any;
  editCompany!: any;
  editClient!: any;
  duplicateInvoiceNumber!: any;
  currencies!: any;

  async $$load_currencies() {
    return this.$app.repo.get('list_currency')
  }

  paymentMethods!: any;

  async $$load_paymentMethods() {
    return this.$app.repo.get('list_payment_method')
      .then(data => _.map(data, p => ({
        value: p.id,
        text: this.$fn.pgettext('PaymentMethod', p.name)
      })))
  }

  expenseTypes!: any;

  async $$load_expenseTypes() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'expense-type' } })
  }

  invoiceStatuses!: any;

  async $$load_invoiceStatuses() {
    return this.$fn.getEnumValuesFromSchema(
      this.isIncomingInvoice ? 'IncomingInvoiceStatus' : 'OutgoingInvoiceStatus',
      { sort: false }
    )
  }

  incomingInvoiceStatuses!: any;

  async $$load_incomingInvoiceStatuses() {
    return this.$fn.getEnumValuesFromSchema('IncomingInvoiceStatus', { sort: false })
  }

  invoiceTypes!: any;

  async $$load_invoiceTypes() {
    return this.$fn.getEnumValuesFromSchema('InvoiceType', { sort: false })
  }

  languages!: any;
  tags!: any;

  async $$load_tags() {
    return this.$app.repo.get('get_tags', { parameters: { tag_type: 'invoice' } }).then(data => _.map(data, p => p.name))
  }

  vatPeriods!: any;

  async $$load_vatPeriods() {
    return this.$app.repo.get('list_vat_periods')
  }

  templates!: any;

  async $$load_templates() {
    return this.$app.repo.get('list_template')
      .then(items => _.filter(items, { object_type: 'invoice_notification' }))
  }

  ux!: any;
  b_6917646200545441_dataSource!: any;
  b_6424600534600827_dataSource!: any;
  dataMembers = ['messages', 'editCompany', 'editClient', 'duplicateInvoiceNumber', 'currencies', 'paymentMethods', 'expenseTypes', 'invoiceStatuses', 'incomingInvoiceStatuses', 'invoiceTypes', 'languages', 'tags', 'vatPeriods', 'templates', 'ux', 'b_6917646200545441_dataSource', 'b_6424600534600827_dataSource'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        messages: {
          invoiceTypes: {
            correction: this.$fn.pgettext("InvoiceType", "Correction"),
            storno: this.$fn.pgettext("InvoiceType", "Storno"),
            proforma: this.$fn.pgettext("InvoiceType", "Pro Forma"),
          }
          ,
          invoiceTypeHelp: {
            normal: this.$fn.pgettext("Invoice|Reference|description", "Normal invoices can reference Pro Forma invoices."),
            correction: this.$fn.pgettext("Invoice|Reference|description", "A correction must reference the invoice being corrected."),
            storno: this.$fn.pgettext("Invoice|Reference|description", "The reversing invoice must reference the invoice being reversed."),
            proforma: this.$fn.pgettext("Invoice|Reference|description", "Pro Forma invoices can reference former Pro Forma invoices."),
          }
          ,
          duplicateInvoiceNumber: this.$fn.pgettext("Invoice", "The given invoice number already exists."),
        }
        ,
        editCompany: false,
        editClient: false,
        duplicateInvoiceNumber: false,
        currencies: null,
        paymentMethods: null,
        expenseTypes: null,
        invoiceStatuses: null,
        incomingInvoiceStatuses: null,
        invoiceTypes: null,
        languages: [{
          value: "hu",
          text: this.$fn.pgettext("Language", "hungarian"),
        }
          ,
        {
          value: "en",
          text: this.$fn.pgettext("Language", "english"),
        }
          ,
        ]
        ,
        tags: null,
        vatPeriods: null,
        templates: null,
        ux: null,
        b_6917646200545441_dataSource: {
          name: "suggest_company",
          parameters: {
            role: "own",
          }
          ,
        }
        ,
        b_6424600534600827_dataSource: {
          name: "suggest_company",
          parameters: {
            role: "partner",
          }
          ,
        }
        ,
      },
    }
  }

  get isReadonly() {
    if (this.loaded) {

      return false
    }
    return null;
  }

  get isIncomingInvoice() {
    if (this.loaded) {

      return this.invoice.invoice_kind == 'incoming'
    }
    return null;
  }

  get isReferenceInvoiceRequired() {
    if (this.loaded) {

      return ['storno', 'correction'].indexOf(this.invoice.invoice_type) > -1
    }
    return null;
  }

  get preventChangeClient() {
    if (this.loaded) {

      return !!this.invoice.reference_invoice
    }
    return null;
  }

  get preventChangeCompany() {
    if (this.loaded) {

      return !!this.invoice.reference_invoice
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  async act_4186377094414664_script_6992_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4186377094414664_script_6992, alias=undefined
    this.onReferenceInvoiceSelected($event.data)
  }

  async act_4186377094414664_script_6992_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4186377094414664_script_6992, alias=undefined
    return {
      value: () => this.act_4186377094414664_script_6992_getActionArgs_value($event),
    }
  }

  async evh_4186377094414664_optionSelected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4186377094414664_optionSelected.executeFromDOM(this, event, scope);
  }

  async act_6917646200545441_script_6994_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6917646200545441_script_6994, alias=undefined
    this.selectCompany({ companyId: this.invoice.company.id })
  }

  async act_6917646200545441_script_6994_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6917646200545441_script_6994, alias=undefined
    return {
      value: () => this.act_6917646200545441_script_6994_getActionArgs_value($event),
    }
  }

  async act_6917646200545441_script_6994_getWhen($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6917646200545441_script_6994, alias=undefined
    return !!this.invoice.company
  }

  async evh_6917646200545441_selected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6917646200545441_selected.executeFromDOM(this, event, scope);
  }

  async act_6424600534600827_script_6996_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6424600534600827_script_6996, alias=undefined
    this.selectClient({ clientId: this.invoice.client.id })
  }

  async act_6424600534600827_script_6996_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6424600534600827_script_6996, alias=undefined
    return {
      value: () => this.act_6424600534600827_script_6996_getActionArgs_value($event),
    }
  }

  async act_6424600534600827_script_6996_getWhen($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6424600534600827_script_6996, alias=undefined
    return !!this.invoice.client
  }

  async evh_6424600534600827_selected(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6424600534600827_selected.executeFromDOM(this, event, scope);
  }

  async act_2754826507016131_script_6998_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_2754826507016131_script_6998, alias=undefined
    this.checkInvoiceNumber(this.invoice.invoice_number)
  }

  async act_2754826507016131_script_6998_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_2754826507016131_script_6998, alias=undefined
    return {
      value: () => this.act_2754826507016131_script_6998_getActionArgs_value($event),
    }
  }

  async evh_2754826507016131_blur_6997_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2754826507016131_blur_6997, alias=undefined
    return this.invoice.isValueChanged('invoice_number')
  }

  async evh_2754826507016131_blur(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2754826507016131_blur.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_6990: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_6989: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
    act_4186377094414664_script_6992: actions.ScriptAction;
    evh_4186377094414664_optionSelected_6991: actions.EventHandlerImpl;
    evh_4186377094414664_optionSelected: actions.EventHandlerGroup;
    act_6917646200545441_script_6994: actions.ScriptAction;
    evh_6917646200545441_selected_6993: actions.EventHandlerImpl;
    evh_6917646200545441_selected: actions.EventHandlerGroup;
    act_6424600534600827_script_6996: actions.ScriptAction;
    evh_6424600534600827_selected_6995: actions.EventHandlerImpl;
    evh_6424600534600827_selected: actions.EventHandlerGroup;
    act_2754826507016131_script_6998: actions.ScriptAction;
    evh_2754826507016131_blur_6997: actions.EventHandlerImpl;
    evh_2754826507016131_blur: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_6990 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_6989 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_6990,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_6989],
      }
    );
    const act_4186377094414664_script_6992 = new actions.ScriptAction(
      {
        actionArgs: this.act_4186377094414664_script_6992_getActionArgs,
        events: [],
      }
    );
    const evh_4186377094414664_optionSelected_6991 = new actions.EventHandlerImpl(
      {
        action: act_4186377094414664_script_6992,
        event: "optionSelected",
        displayName: "script",
      }
    );
    const evh_4186377094414664_optionSelected = new actions.EventHandlerGroup(
      {
        handlers: [evh_4186377094414664_optionSelected_6991],
      }
    );
    const act_6917646200545441_script_6994 = new actions.ScriptAction(
      {
        actionArgs: this.act_6917646200545441_script_6994_getActionArgs,
        when: this.act_6917646200545441_script_6994_getWhen,
        events: [],
      }
    );
    const evh_6917646200545441_selected_6993 = new actions.EventHandlerImpl(
      {
        action: act_6917646200545441_script_6994,
        event: "selected",
        displayName: "script",
      }
    );
    const evh_6917646200545441_selected = new actions.EventHandlerGroup(
      {
        handlers: [evh_6917646200545441_selected_6993],
      }
    );
    const act_6424600534600827_script_6996 = new actions.ScriptAction(
      {
        actionArgs: this.act_6424600534600827_script_6996_getActionArgs,
        when: this.act_6424600534600827_script_6996_getWhen,
        events: [],
      }
    );
    const evh_6424600534600827_selected_6995 = new actions.EventHandlerImpl(
      {
        action: act_6424600534600827_script_6996,
        event: "selected",
        displayName: "script",
      }
    );
    const evh_6424600534600827_selected = new actions.EventHandlerGroup(
      {
        handlers: [evh_6424600534600827_selected_6995],
      }
    );
    const act_2754826507016131_script_6998 = new actions.ScriptAction(
      {
        actionArgs: this.act_2754826507016131_script_6998_getActionArgs,
        events: [],
      }
    );
    const evh_2754826507016131_blur_6997 = new actions.EventHandlerImpl(
      {
        action: act_2754826507016131_script_6998,
        event: "blur",
        when: this.evh_2754826507016131_blur_6997_getWhen,
        displayName: "script",
      }
    );
    const evh_2754826507016131_blur = new actions.EventHandlerGroup(
      {
        handlers: [evh_2754826507016131_blur_6997],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_6990,
      evh_7315092382398562_reload_6989,
      evh_7315092382398562_reload,
      act_4186377094414664_script_6992,
      evh_4186377094414664_optionSelected_6991,
      evh_4186377094414664_optionSelected,
      act_6917646200545441_script_6994,
      evh_6917646200545441_selected_6993,
      evh_6917646200545441_selected,
      act_6424600534600827_script_6996,
      evh_6424600534600827_selected_6995,
      evh_6424600534600827_selected,
      act_2754826507016131_script_6998,
      evh_2754826507016131_blur_6997,
      evh_2754826507016131_blur,
    }
  }
}

Vue.component("FieldsetInvoiceHeader", FieldsetInvoiceHeader);

</script>